import { BaseRouteReuseStrategy } from '@angular/router';

export class ReloadRouteReuseStrategy extends BaseRouteReuseStrategy {
    shouldReuseRoute(): boolean {
        return false;
    }
}
